import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const rows = [
  {
    section: 'Medical Course',
    items: [
      ['ANAGHA G R', 'Medicine', 'East Point Medical College'],
    ],
  },
  {
    section: 'Other Professional Courses',
    items: [
      ['ADITTI PADMANABHAN', 'B Design', 'National Institute of Design, Amaravati'],
      ['ADITYA SHANKER', 'BALLB(Hons.)', 'Jindal Global Law School, Sonipat'],
      ['KESHAV MANIKERNIKA', 'BA LLB (Honours)', 'Christ University'],
      ['SAMRIT SAMEEP KUNJA', 'National Defence Academy', 'Pune'],
      ['SHREYA ARORA', 'BSc(Economics)', 'Christ University'],
    ],
  },
  {
    section: 'Engineering Courses',
    items: [
      ['ADVAITA SHARMA', 'Computer Science Engineering Internet of things', 'Vellore Institute of Technology'],
      ['AISHWARYA B', 'Computer Science Engineering', 'MS Ramaiah University'],
      ['CHHAVI KHANNA', 'Architecture', 'Virginia Tech , USA'],
      ['HAREN C HIREMATH', 'Aeronautical Engineering', 'Hindustan Institute of technology and science'],
      ['MAHIMA PRASANNA', 'Bachelor of Design', 'IIT Guwahati'],
      ['MAITHILI SUNIL SAHASRABUDHE', 'BSc. Microbiology and Chemistry', "St Joseph's College Autonomous"],
      ['NAVYA SRINIVASAN', 'BTech+MSc', 'BITS Pilani'],
      ['RIYA MAHESH', 'Electrical Engineering', 'IIT Madras'],
      ['SAAMI', 'Computer Science Engineering', 'Presidency University'],
      ['SWARIT SINGH CHAUHAN', 'Bachelor of Engineering', 'University of Canterbury, Christchurch,NewZealand'],
      ['AMALA RASHMI KUMAR', 'Information Science', 'MS Ramaiah Institute of technology'],
      ['ANKITHA A', 'Architecture', 'BMS School of Architecture. Yelhanka'],
      ['AYUSHMAAN SRIVASTAVA', 'EEE', 'NITK Surathkal'],
      ['B P PRADYUMNA', 'Electronics and Communication', 'NITTE Engineering College'],
      ['NIRMAL GOVINDARAJ', 'Computer Science', 'BITS Goa'],
      ['NIYATI SINGH', 'Information Science', 'MS Ramaiah Institute of technology'],
      ['S MEENA KUMARI', 'Computer Science Engineering', 'MS Ramaiah Institute of technology'],
      ['S SAUJANYA', 'Computer Science Engineering', 'PES Electronic city'],
      ['SAMARTH VIJAY KUMAR', 'Mechanical Engineering', 'MS Ramaiah Institute of technology'],
      ['SHALINI KAMMALAM S', 'Computer Science Engineering', 'PES Electronic city'],
      ['SIRI R', 'Computer Science Engineering', 'PES Ring Road'],
      ['SNEHAL SALIAN', 'Computer Science Engineering', 'Acharya Engineering College'],
      ['VIDHYOTHA SHETTY', 'Electronics Engineering', 'Manipal Institute of Technology'],
      ['S KARTHIKEYAN', 'Mechanical Engineering', 'PES RR Campus'],
      ['S V VENKATA SAI VISHWESWAR', 'B Tech+M Tech, Bio Engineering', 'IIT Madras'],
    ],
  },
];

const Features = () => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 200 }} aria-label="alumni placements table">
        <TableBody>
          {rows.map((group) => (
            <React.Fragment key={group.section}>
              <TableRow>
                <TableCell colSpan={3} sx={{ py: 1 }}>
                  <Typography align="center" variant="h5" fontWeight={500}>
                    {group.section}
                  </Typography>
                </TableCell>
              </TableRow>
              {group.items.map(([name, course, college]) => (
                <TableRow
                  key={`${group.section}-${name}`}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    <Typography variant="subtitle2" fontWeight={700}>
                      {name}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="text.secondary" variant="subtitle2">
                      {course}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="text.secondary" variant="subtitle2">
                      {college}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Features;
